import script from "./CustomHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomHeader.vue?vue&type=script&setup=true&lang=ts"

import "./CustomHeader.vue?vue&type=style&index=0&id=7baddba3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7baddba3"]])

export default __exports__